export default __webpack_public_path__ + "static/media/architectural.beff3865.jpg";